import { Badge, Row, Table, List } from 'reactstrap';

const EquipStats = ({ skillset, stats, passive, star }) => {
    const skillbreak = skillset.break ?? skillset.skillbreak;

    return (
        <center>
            <RenderStats hp={stats.hp} atk={stats.atk} def={stats.def} star={star} />
            <RenderSkill skillbreak={skillbreak} skilleffect={skillset.skill} />
            <RenderPassives passive={passive} />
        </center>
    )
}

const RenderStats = ({ hp, atk, def, star }) => {
    return (
        <Row className="gs-unit-block">
            <div className="gs-unit-table-scroll gs-unit-table-scroll--art">
                <Table bordered className="gs-unit-table">
                    <tbody>
                        <tr>
                            <th>
                                <center>HP</center>
                            </th>
                            <th>
                                <center>ATK</center>
                            </th>
                            <th>
                                <center>DEF</center>
                            </th>
                            <th>
                                <center>Rarity</center>
                            </th>
                        </tr>
                        <tr>
                            <td><center>{hp}</center></td>
                            <td><center>{atk}</center></td>
                            <td><center>{def}</center></td>
                            <td><center><RenderRarity rarity={star} /></center></td>
                        </tr>
                    </tbody>
                </Table>
            </div>
            <p className="gs-unit-detail__note">
                <i>Stats and Skillset shown are based on Max Level and Max Limit Break</i>
            </p>
        </Row>
    )
}

const RenderRarity = ({ rarity }) => {
    switch(rarity) {
        case 1: 
            return (
                <>
                    ☆
                </>
            )
        case 2:
            return (
                <>☆☆</>
            )
        case 3: 
            return (
                <>☆☆☆</>
            )
        case 4:
            return (
                <>☆☆☆☆</>
            )
        case 5:
            return (
                <>☆☆☆☆☆</>
            )
        case 6:
            return (
                <>☆☆☆☆☆☆</>
            )
        default:
            return null;
    }
}

const RenderSkill = ({ skillbreak, skilleffect }) => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">SKILL</h3>
            <center>
                <p>
                    {skilleffect}&nbsp;<Badge className="gs-badge gs-badge--accent" pill>{skillbreak} BREAK</Badge>
                </p>
            </center>
        </Row>
    )
}

const RenderPassives = ({ passive }) => {
    return (
        <Row className="gs-unit-block">
            <h3 className="gs-unit-section-title">PASSIVES</h3>
            <List type="unstyled" className="gs-unit-passive-list">
                { 
                    passive.ability1 ? 
                        <>
                            {
                                Array.isArray(passive.ability1) 
                                ? 
                                    <RenderAbilityList ability={passive.ability1} num={1} />
                                :
                                    <li>{passive.ability1}</li>
                            }
                        </>
                        
                    : 
                    <li>This Equip has no passive</li> 
                }
                { 
                    passive.ability2 ? 
                    <>
                            {
                                Array.isArray(passive.ability2) 
                                ? 
                                    <RenderAbilityList ability={passive.ability2} num={2} />
                                :
                                    <li>{passive.ability2}</li>
                            }
                    </>
                    : null
                }
                { 
                    passive.ability3 ? 
                    <>
                            {
                                Array.isArray(passive.ability3) 
                                ? 
                                    <RenderAbilityList ability={passive.ability3} num={3} />
                                :
                                    <li>{passive.ability3}</li>
                            }
                    </>
                    : null
                }
                { 
                    passive.ability4 ? <li>{passive.ability4}</li> : null
                }
            </List>
        </Row>
    )
}

const RenderAbilityList = ({ ability, num }) => {
    return (
        <li>
            <p className="gs-unit-detail__note">
                <i>Passive {num} is randomly assigned from this List:</i>
            </p>
            <List type="unstyled" className="gs-unit-passive-list">
                {
                    ability.map((entry, index) => (
                        <li key={`${num}-${index}`}>{entry}</li>
                    ))
                }
            </List>
        </li>
    )
}

export default EquipStats;
